import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Input, Button } from "@oc-labs/wt-storybook";
import ModalV2 from "../../ModalV2";
import useModal from "../../../hooks/useModal";

const MODAL_NAME = "translation-upsert-term";

export default function UpsertTermModal({ translationAdmin }) {
  const { close, data } = useModal(MODAL_NAME);
  const [isEditing, setIsEditing] = useState(false);
  const [term, setTerm] = useState({
    projectId: "",
    term: "",
    description: "",
  });

  useEffect(() => {
    if (!data) {
      setTerm({ projectId: "", term: "", description: "" });
      setIsEditing(false);
      return;
    }

    const incomingTerm = data?.term ?? "";
    const description = data?.description ?? "";
    const projectId = data?.projectId ?? "";

    if (!projectId) {
      toast.error("Please select a project first");
      close();
      return;
    }

    setTerm({ term: incomingTerm, description, projectId });
    setIsEditing(Boolean(incomingTerm));
  }, [data]);

  const handleConfirm = async () => {
    await translationAdmin.upsertTerm(term);
    close();
    toast.success("Term added successfully");
  };

  const handleSlugifyTerm = (e) => {
    setTerm({
      ...term,
      term: e?.target?.value?.toLowerCase().replace(/[^a-z0-9]/g, "_"),
    });
  };

  return (
    <ModalV2 name={MODAL_NAME} title={isEditing ? "Edit Term" : "Create Term"} className="w-full max-w-md">
      <div className="space-y-6">
        <div className="space-y-4">
          <Input
            label="Term"
            disabled={isEditing}
            value={term.term}
            onChange={handleSlugifyTerm}
            placeholder="Term"
            type="text"
          />
          <Input
            label="Description"
            value={term.description}
            onChange={(e) =>
              setTerm({ ...term, description: e.target.value })
            }
            placeholder="Description"
            type="text"
          />
        </div>

        <div className="flex gap-4 pt-2">
          <Button type="tertiary" className="w-1/2" onClick={close}>
            Cancel
          </Button>

          <Button type="primary" className="w-1/2" onClick={handleConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </ModalV2>
  );
}
